import { makeRequest, CommonRequestOptions } from './makeRequest';
import { BulletStyles } from './guides/types';

export async function getBulletStyles({ ...common }: CommonRequestOptions): Promise<BulletStyles> {
   return await makeRequest('get', 'bullet-styles', common);
}
